import gql from 'graphql-tag';

import client from '../graphqlAPI';

const POST_ADD_POST_MUTATION = gql`
  mutation Post($components: String!, $postCategory: [String], $postDescription: ObjectPostDescriptionInput, $slugName: String!, $postName: String, $rolesAllowed: [String], $active: Boolean, $noIndex: Boolean, $type: String, $requiresCompleteRegistration: Boolean) {
    postAddPost(components: $components, postCategory: $postCategory, postDescription: $postDescription, slugName: $slugName, postName: $postName, rolesAllowed: $rolesAllowed, active: $active, noIndex: $noIndex, type: $type, requiresCompleteRegistration: $requiresCompleteRegistration) {
      isAuth
      isAdded
      slugName
    }
  }
`;

const postAddPost = async ({
  components, active, postCategory, postDescription, slugName, postName, type, rolesAllowed, noIndex, requiresCompleteRegistration,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_ADD_POST_MUTATION,
        variables: {
          components,
          postCategory,
          postDescription,
          slugName,
          postName,
          rolesAllowed,
          active,
          noIndex,
          type,
          requiresCompleteRegistration,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postAddPost: postAddPostValidationData },
    } = result;

    if (postAddPostValidationData) {
      return postAddPostValidationData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postAddPostValidationData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postAddPost Error: ${error}`);
    return null;
  }
};

export default postAddPost;
